/** Maps formatted report totals onto a shared, zero-based chart scale. */
export function currencyChart(items) {
  const values = items.map(({ total }) => {
    const value = Number(String(total ?? "").replace(/,/g, ""));
    return Number.isFinite(value) ? value : 0;
  });
  const min = Math.min(0, ...values);
  const max = Math.max(0, ...values);
  const range = max - min || 1;

  return {
    zero: (Math.abs(min) / range) * 100,
    ticks: Array.from({ length: 5 }, (_, index) => min + (range * index) / 4),
    bars: items.map((item, index) => ({
      ...item,
      left: ((Math.min(0, values[index]) - min) / range) * 100,
      width: (Math.abs(values[index]) / range) * 100,
    })),
  };
}
